import React from 'react';

const TextField = ({ errorClassName , preferNotToSayButton, checkboxRegister, errorMessage, labelClassName, labelName , inputClassName,  register , error ,  ...props}) => {
  return (
    <label className={labelClassName}>
      {labelName}
      <input
      { ...register }
      className={inputClassName}
      { ...props }
      />
      <div className={errorClassName}>{ error && (errorMessage ? errorMessage : "This field is required") }</div>
    </label>
  )
}

export default TextField